

import { ref } from 'vue'
import FETCHING from '../../library/fetching'
import DATA_MASTER from '../../library/dataMaster'
import UMUM from '../../library/umum'

export default {
  data() {
    return {

      form : {
        id : '',
        nama:'',
        deskripsi : '',
        tahun : '',
        tipe:'',
        file : null,
        status:'',
        statusf:null,
        jk:'',
        pesan :'',
        verifikasi: '',
        keterangan_ver: '',
        tindaklanjut: '',
        keterangan_tl: ''

      },


      filterku : {
        unit_kerja : '',
      },

      // ====================================== CONTOH AUTOCOMPLETE ====================================
      autocomplete_db : '',
      // ====================================== CONTOH AUTOCOMPLETE ====================================
      
      list_kategoripenolakan:[],
      list_data : [],
      list_lampiran : [],

      cari_value: "",
      page_first: 1,
      page_last: 0,
      page_limit : 10,

      page_first1: 1,
      page_last1: 0,
      page_limit1 : 10,
      cek_load_data : true,


      mdl_add: false,
      mdl_edit: false,
      mdl_hapus : false,
      mdl_lampiran : false,
      mdl_riwayat : false,
      mdl_diterima : false,
      mdl_cetak : false,
      btn_add: false,
      mdl_laporan: false,


      FETCHING : FETCHING,
      DATA_MASTER : DATA_MASTER,
      UMUM : UMUM,
      file_old : "",
      file_path: this.$store.state.url.URL_APP + "uploads/",
    }
 

  },
  setup () {
    return {
      customModel: ref(false)
    }
  },

  methods: {


    getView : function(){
      this.cek_load_data = true;
      fetch(this.$store.state.url.URL_TINDAKLANJUT + "view", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              cari_value: this.cari_value,
              page_limit: this.page_limit,
              statusf: this.form.statusf,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              this.cek_load_data = false;
              console.log(res_data);
      });
    },


    selectData : function(data){
      this.form.id = data.id;
        this.form.judul = data.judul;
        this.form.nama = data.nama;
        this.form.deskripsi = data.deskripsi;
        this.form.tahun = data.tahun;
        this.form.tipe = data.tipe;
        this.form.hp = data.hp;
        this.form.jk = data.jk;
        this.form.alamat = data.alamat;
        this.form.pekerjaan = data.pekerjaan;
        this.form.status = data.status;
        this.form.file = data.file;
        this.file_old = data.file;
        this.form.nik = data.nik;
        this.form.opdterlapor = data.opdterlapor;
        this.form.aduan = data.aduan;
        this.form.verifikasi = data.verifikasi;
        this.form.keterangan_ver = data.keterangan_ver;
        this.form.tindaklanjut = data.tindaklanjut;
        this.form.keterangan_tl = data.keterangan_tl;
    },


    diterima : function() {
        fetch(this.$store.state.url.URL_TINDAKLANJUT + "diterima", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
           body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Menyetujui Data', 'primary', 'check_circle_outline');
          this.getView();
      });
    },


  cari_data_penerima : function (){
    console.log("hai")
  },





    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },
        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },
        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        },


    // ====================================== PAGINATE ====================================

    exportExcel : function () {
      let table = document.getElementByID("table");
      TableToExcel.convert(table[0], {
        name: `file.xlsx`,
        sheet: {
          name: 'Sheet 1'
        }
      });
      console.log('first')
    },


  },

  mounted () {
    var get_profile = JSON.parse(localStorage.profile);
    // this.unit_kerja_id = get_profile.profile.unit_kerja;
    this.getView();
  },
}
